import { Box, LinearProgress, Stack, Typography } from "@mui/material";

export interface IPerformanceThreshold {
  low: number;
  high: number;
}

export const PerformanceProgressBar = ({
  count,
  rate,
  threshold,
  reverse = false,
}: {
  count: number;
  rate: number;
  threshold: IPerformanceThreshold;
  reverse?: boolean;
}) => (
  <Box>
    {count}
    <Stack flexDirection="row" gap={1} alignItems="center">
      <Typography fontSize="small">{Math.min(rate, 100).toFixed(2)}%</Typography>
      <LinearProgress
        variant="determinate"
        value={Math.min(rate, 100)}
        sx={{
          borderRadius: 5,
          height: 11,
          width: 1,
          backgroundColor: "#EBEBEB",
          "& .MuiLinearProgress-bar": {
            borderRadius: 0,
            backgroundColor: getProgressColor(rate, threshold, reverse),
          },
        }}
      />
    </Stack>
  </Box>
);

const colorMap = {
  positive: "#80D879",
  neutral: "#FCD712",
  negative: "#F85757",
};

// Get color based on 0-100 value
const getProgressColor = (value: number, threshold: IPerformanceThreshold, reverse = false) => {
  if (value <= threshold.low) {
    return reverse ? colorMap.positive : colorMap.negative;
  } else if (value < threshold.high) {
    return colorMap.neutral;
  } else {
    return reverse ? colorMap.negative : colorMap.positive;
  }
};
